document.addEventListener('product-configurator:bundle-added', async (event) => {
  try {
    if (!window.FoxTheme?.routes?.cart_url || !window.FoxTheme?.pubsub) return;

    const addResponse = event.detail?.cartAddResponse;
    if (!addResponse || addResponse.status) return;

    // Ask theme components which section IDs they want rendered.
    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      }),
    );

    // Match theme.js behavior: refresh cart JSON after add.
    const cartJson = await (
      await fetch(
        `${FoxTheme.routes.cart_url}`,
        { ...FoxTheme.utils.fetchConfig('json', 'GET') },
      )
    ).json();

    // Prefer bundled sections returned by /cart/add.
    if (addResponse.sections) {
      cartJson.sections = addResponse.sections;
    } else if (sectionsToBundle.length) {
      // Fallback in case add response did not include section HTML.
      const sectionUrl = new URL(FoxTheme.routes.cart_url, window.location.origin);
      sectionUrl.searchParams.set('sections', sectionsToBundle.join(','));
      sectionUrl.searchParams.set('sections_url', window.location.pathname);

      const sectionData = await (
        await fetch(sectionUrl.toString(), { ...FoxTheme.utils.fetchConfig('json', 'GET') })
      ).json();

      cartJson.sections = sectionData.sections || sectionData;
    }

    // THIS is the main update pathway used by cart.js/components.
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });

    // Match product-form behavior in theme.js.
    document.dispatchEvent(
      new CustomEvent('product-ajax:added', {
        detail: { product: addResponse },
      }),
    );

    // Optional: keeps listeners like free-shipping-goal in sync even if they
    // only listen for cart:updated and not pubsub updates.
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: { cart: cartJson },
      }),
    );

    // Open drawer like theme product form does.
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') {
      drawer.show(document.activeElement);
    }
  } catch (error) {
    console.error('[product-configurator] bundle-added handler failed', error);
  }
});
document.addEventListener('product-configurator:bundle-main-variant-changed', function (e) {
  const { rootProductId, variantId } = e.detail || {};
  if (rootProductId == null || variantId == null) return;

  const productInfo = document.querySelector(
    `product-info[data-product-id="${rootProductId}"]`,
  );
  if (!productInfo) return;

  // Matches native picker: product-info.updateURL (not buildRequestUrlWithParams — that is for section fetch URLs).
  if (typeof productInfo.updateURL === 'function') {
    productInfo.updateURL(productInfo.dataset.url, variantId);
  }
  if (typeof productInfo.updateMediaFromVariantId === 'function') {
    productInfo.updateMediaFromVariantId(variantId);
  }
});